import { dummyCourse } from '../../models/LearningItem'
import { useLearningItem } from '../entities'

export function useOnDemandCourse(uuid?: string) {
  const { learningItem } = useLearningItem(uuid)

  if (learningItem.kind !== 'onDemandCourse') {
    if (learningItem.isDummy) {
      return { course: dummyCourse(learningItem.uuid, learningItem.error) }
    }
    return { course: dummyCourse(learningItem.uuid, new Error('Not a course')) }
  }

  return { course: learningItem }
}
